var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mui-list-subtitle",attrs:{"role":"menuitem"}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.action)?_c('div',{staticClass:"mui-list-subtitle__actions"},[_c('i',{staticClass:"material-icons",attrs:{"role":"button","title":_vm.action.title},on:{"click":_vm.action.fn}},[_vm._v(_vm._s(_vm.action.icon))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c43d87e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MUIListSubtitle.vue
// module id = null
// module chunks = 